<template>
  <div>
    <div class="table">
      <el-table
        style="margin-bottom: 20px"
        :data="reports"
        width="100%"
        v-loading="loading"
        empty-text="No Attendance Summary Reports available."
        class="colored-head"
      >
        <el-table-column prop="employee_details" label="Name" width="200">
          <template slot-scope="scope">
            <div>
              {{ scope.row.employee_details.name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="employee_details" label="Pin" width="200">
          <template slot-scope="scope">
            <div>
              {{ scope.row.employee_details.pin }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="employee_details"
          label="Custom Id"
          width="200"
          v-if="'custom_employee_id' in reports[0].employee_details"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.employee_details.custom_employee_id || "NA" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="employee_details"
          label="Employee Grade"
          width="200"
          v-if="'employee_grade' in reports[0].employee_details"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.employee_details.employee_grade || "NA" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="employee_details"
          label="Employee Type"
          width="200"
          v-if="'employee_type' in reports[0].employee_details"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.employee_details.employee_type || "NA" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="employee_details"
          label="Employee Category"
          width="200"
          v-if="'employee_category' in reports[0].employee_details"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.employee_details.employee_category || "NA" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="employee_details"
          label="Mobile Number"
          width="200"
          v-if="'mobile_number' in reports[0].employee_details"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.employee_details.mobile_number || "NA" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="employee_details"
          label="Email"
          width="200"
          v-if="'email' in reports[0].employee_details"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.employee_details.email || "NA" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="employee_details"
          label="Department"
          width="200"
          v-if="'department' in reports[0].employee_details"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.employee_details.department || "NA" }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="employee_details"
          label="Branch"
          width="200"
          v-if="'branch' in reports[0].employee_details"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.employee_details.branch || "NA" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          sortable
          prop="days_clockin_and_out"
          label="DAYS CLOCKED IN & OUT"
          width="250"
        ></el-table-column>
        <el-table-column
          sortable
          prop="hours_late"
          label="HOURS LATE"
          width="220"
        ></el-table-column>
        <el-table-column
          sortable
          prop="no_clockin"
          label="NO CLOCKIN"
          width="220"
        ></el-table-column>
        <el-table-column
          sortable
          prop="no_clockout"
          label="NO CLOCKOUT"
          width="220"
        ></el-table-column>
        <el-table-column
          sortable
          prop="num_days_absent"
          label="DAYS ABSENT"
          width="220"
        ></el-table-column>
        <el-table-column
          v-if="onLeaveCountField"
          sortable
          :prop="onLeaveCountField"
          label="DAYS ON LEAVE"
          width="220"
        ></el-table-column>
        <el-table-column
          sortable
          prop="num_lateness"
          label="DAYS LATE"
          width="220"
        ></el-table-column>
        <el-table-column
          sortable
          prop="hours_worked"
          label="HOURS WORKED"
          width="220"
        ></el-table-column>
        <el-table-column
          sortable
          prop="expected_total_hours"
          label="EXP. HOURS WORKED"
          width="220"
        ></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["reports", "groupby", "loading"],
  computed: {
    onLeaveCountField() {
      const firstRow =
        this.reports && this.reports.length ? this.reports[0] : {};

      if (Object.prototype.hasOwnProperty.call(firstRow, "num_days_on_leave")) {
        return "num_days_on_leave";
      }

      if (Object.prototype.hasOwnProperty.call(firstRow, "days_on_leave")) {
        return "days_on_leave";
      }

      if (Object.prototype.hasOwnProperty.call(firstRow, "num_on_leave_days")) {
        return "num_on_leave_days";
      }

      return "";
    },
  },
};
</script>
